var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.999377C7 0.999377 14 0.499803 18.5 0.999377C23 1.49895 25 4.97395 25 8.99938C25 13.0248 23 16.9994 18.5 16.9994C14 16.9994 7 16.9994 7 16.9994",
    stroke: "#255097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 24.9996C19 24.9996 12 25.4992 7.5 24.9996C3 24.5001 1 21.0251 1 16.9996C1 12.9742 3 8.99965 7.5 8.99965C12 8.99965 19 8.99965 19 8.99965",
    stroke: "#255097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimary);
export default __webpack_public_path__ + "static/media/primary.2fc8f3c0c161ffc8f6d63a0292958fc3.svg";
export { ForwardRef as ReactComponent };